(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('.column-options__option-input');
    const grid = document.querySelector('[product-grid-view]');

    inputs.forEach(input => {
      input.addEventListener('change', () => {
        if (grid) {
          grid.setAttribute('product-grid-view', input.value);
          sessionStorage.setItem('product-grid-view-desktop', input.value);
        }
      });
    });

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const saved = sessionStorage.getItem('product-grid-view-desktop');

    if (isDesktop && saved && grid) {
      grid.setAttribute('product-grid-view', saved);
      const savedInput = document.querySelector(`.column-options__option-input[value="${saved}"]`);
      if (savedInput) savedInput.checked = true;
    } else if (!isDesktop && grid) {
      grid.setAttribute('product-grid-view', 'default');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
